export default __webpack_public_path__ + "static/img4-cb741718dacb45c0e87ddf0fb634f12b.png";